import { breakpoints } from './breakpoints'

import { getPalette } from './palette'
import { MuiButton } from './overrides/Button'
import { palette } from 'theme/palette'
import { typography } from './Typography'
import { createTheme } from '@mui/material'

export const getTheme = (mode = 'light') =>
  createTheme({
    breakpoints,
    palette: palette(mode),
    typography,
    shape: {
      borderRadius: 8,
    },
    components: {
      MuiButton,
    },
  })
